export const FETCH_CONNECTION_RUN_STATUS = 'FETCH_CONNECTION_RUN_STATUS';
export const FETCH_CONNECTION_RUN_STATUS_SUCCESS = 'FETCH_CONNECTION_RUN_STATUS_SUCCESS';
export const FETCH_CONNECTION_RUN_STATUS_FAILURE = 'FETCH_CONNECTION_RUN_STATUS_FAILURE';
export const FETCH_TOTAL_PROVISION_QUALITY = 'FETCH_TOTAL_PROVISION_QUALITY';
export const FETCH_CONNECTIONS_QUALITY = 'FETCH_CONNECTIONS_QUALITY';
export const FETCH_BUSINESSES_QUALITY = 'FETCH_BUSINESSES_QUALITY';
export const FETCH_USEFUL_STATS = 'FETCH_USEFUL_STATS';
export const FETCH_TOTAL_PROVISION_QUALITY_SUCCESS = 'FETCH_TOTAL_PROVISION_QUALITY_SUCCESS';
export const FETCH_CONNECTIONS_QUALITY_SUCCESS = 'FETCH_CONNECTIONS_QUALITY_SUCCESS';
export const FETCH_BUSINESSES_QUALITY_SUCCESS = 'FETCH_BUSINESSES_QUALITY_SUCCESS';
export const FETCH_USEFUL_STATS_SUCCESS = 'FETCH_USEFUL_STATS_SUCCESS';
export const FETCH_TOTAL_PROVISION_QUALITY_FAILURE = 'FETCH_TOTAL_PROVISION_QUALITY_FAILURE';
export const FETCH_CONNECTIONS_QUALITY_FAILURE = 'FETCH_CONNECTIONS_QUALITY_FAILURE';
export const FETCH_BUSINESSES_QUALITY_FAILURE = 'FETCH_BUSINESSES_QUALITY_FAILURE';
export const FETCH_USEFUL_STATS_FAILURE = 'FETCH_USEFUL_STATS_FAILURE';
export const FETCH_BUSINESS_CODES = 'FETCH_BUSINESS_CODES';
export const FETCH_BUSINESS_CODES_SUCCESS = 'FETCH_BUSINESS_CODES_SUCCESS';
export const FETCH_BUSINESS_CODES_FAILURE = 'FETCH_BUSINESS_CODES_FAILURE';
export const FETCH_SINGLE_PROVISION_QUALITY = 'FETCH_SINGLE_PROVISION_QUALITY';
export const FETCH_SINGLE_PROVISION_QUALITY_SUCCESS = 'FETCH_SINGLE_PROVISION_QUALITY_SUCCESS';
export const FETCH_SINGLE_PROVISION_QUALITY_FAILURE = 'FETCH_SINGLE_PROVISION_QUALITY_FAILURE';
export const SELECT_RESOURCE_TYPE = 'SELECT_RESOURCE_TYPE';
export const SELECT_BUSINESS_CODE = 'SELECT_BUSINESS_CODE';
export const FETCH_CONNECTION_MONITOR_DATA = 'FETCH_CONNECTION_MONITOR_DATA';
export const FETCH_CONNECTION_MONITOR_DATA_SUCCESS = 'FETCH_CONNECTION_MONITOR_DATA_SUCCESS';
export const FETCH_CONNECTION_MONITOR_DATA_FAILURE = 'FETCH_CONNECTION_MONITOR_DATA_FAILURE';
export const FETCH_HEARTBEAT_MONITOR_STATUS = 'FETCH_HEARTBEAT_MONITOR_STATUS';
export const FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS = 'FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS';
export const FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE = 'FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE';
export const FETCH_NOTIFICATIONS_PANEL_DATA = 'FETCH_NOTIFICATIONS_PANEL_DATA';
export const FETCH_COMMUNICATIONS_SUCCESS = 'FETCH_COMMUNICATIONS_SUCCESS';
